import { CommonModule, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TooltipComponent } from '../../../../../shared/component/tooltip/tooltip.component';

interface SelectButtonFieldProps extends FormlyFieldProps {
  isMultiple: boolean;
  variant?: 'default' | 'blue';
  selectButtonOptions: {
    label: string;
    value: number | string | boolean;
    tooltip?: string;
  }[];
}

@Component({
  selector: 'app-select-button-field',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    SelectButtonModule,
    NgIf,
    TooltipComponent,
    CommonModule,
  ],
  templateUrl: './select-button-field.component.html',
  styleUrl: './select-button-field.component.scss',
})
export class SelectButtonFieldComponent extends FieldType<
  FieldTypeConfig<SelectButtonFieldProps>
> {
  override defaultOptions = {
    props: {
      isMultiple: false,
      selectButtonOptions: undefined,
    },
  };
}
